export default "__VITE_ASSET__36196064__"